import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { getTimeFormat } from "../../../../../utils/utils";

const WorkingHours = ({ day, start, end, style, bgdis }: any) => {
  const intl = useIntl();
  const [workingShift, setWorkingShift] = useState<boolean>(false);

  useEffect(() => {
    console.log(day, start, end);

    const isWorking =
      formatHour(dayjs(start, "HH:mm:ss").hour()) !== 0 &&
      formatHour(dayjs(end, "HH:mm:ss").hour()) !== 0;
    setWorkingShift(isWorking);
  }, [day, start, end]); // This useEffect will run whenever day, start, or end change

  const getTimePeriod = (hour: number) => {
    return hour < 12
      ? intl.formatMessage({ id: "morning" })
      : intl.formatMessage({ id: "evening" });
  };

  // Function to format the hour in 12-hour format
  const formatHour = (hour: number) => {
    return hour <= 12 ? hour : hour - 12;
  };
  console.log(workingShift);
// +':' + dayjs(start, 'HH:mm:ss').minute();
  return (
    <div
      className={`px-4 py-3 ${
        workingShift ? 'bg-white' : `bg-[#CFCFE2] ${bgdis}`
      }  rounded-lg text-center my-6 ${style} w-full`}
    >
      <h3 className="text-black text-sm font-semibold mb-4">{day}</h3>
      <div className="flex gap-3 py-1 w-full justify-center">
        {workingShift ? (
          <div className="flex items-center justify-center gap-1 py-1 px-2 rounded bg-white ">
            <div className="flex items-center justify-center gap-1 w-full">
              <h4 className="text-color-primary font-semibold">
                {/* {formatHour(dayjs(start, 'HH:mm:ss').hour())} */}
                {getTimeFormat(start)}
              </h4>
              <h6 className="text-[#9999A7] font-medium text-[10px] mt-1">
                {getTimePeriod(dayjs(start, 'HH:mm:ss').hour())}
              </h6>
            </div>
            <div className="w-full">-</div>
            <div className="flex items-center justify-center gap-1 w-full">
              <h4 className="text-color-primary font-semibold">
                {/* {formatHour(dayjs(end, 'HH:mm:ss').hour())} */}
                {getTimeFormat(end)}
              </h4>
              <h6 className="text-[#9999A7] font-medium text-[10px] mt-1">
                {getTimePeriod(dayjs(end, 'HH:mm:ss').hour())}
              </h6>
            </div>
          </div>
        ) : (
          <div className="text-color-primary w-full">
            <span className="text-[#9999A7] p-2 py-1 rounded-md text-[14px] font-semibold">
              {intl.formatMessage({ id: 'closed' })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkingHours;
